module.exports = __webpack_public_path__ + "img/boqinspect4_7-8-2021.1287cab9.jpg";